import { DropdownComponentStyles } from './types';

export const mergeComponentStyles = (
  defaultComponentStyles: DropdownComponentStyles,
  componentStyles: DropdownComponentStyles | undefined,
): DropdownComponentStyles => {
  if (componentStyles == null) return defaultComponentStyles;
  return {
    container: [defaultComponentStyles.container, componentStyles?.container],
    containerDisabled: [
      defaultComponentStyles.containerDisabled,
      componentStyles?.containerDisabled,
    ],
    menuItem: [defaultComponentStyles.menuItem, componentStyles?.menuItem],
    menuItemText: [
      defaultComponentStyles.menuItemText,
      componentStyles?.menuItemText,
    ],
    inputContainer: [
      defaultComponentStyles.inputContainer,
      componentStyles?.inputContainer,
    ],
    inputContainerDisabled: [
      defaultComponentStyles.inputContainerDisabled,
      componentStyles?.inputContainerDisabled,
    ],
    input: [defaultComponentStyles.input, componentStyles?.input],
    inputDisabled: [
      defaultComponentStyles.inputDisabled,
      componentStyles?.inputDisabled,
    ],
    focusedInputContainer: [
      defaultComponentStyles.focusedInputContainer,
      componentStyles?.focusedInputContainer,
    ],
    focusedInput: [
      defaultComponentStyles.focusedInput,
      componentStyles?.focusedInput,
    ],
    dropdownContainer: [
      defaultComponentStyles.dropdownContainer,
      componentStyles?.dropdownContainer,
    ],
    dropdown: [defaultComponentStyles.dropdown, componentStyles?.dropdown],
    dropdownContentContainer: [
      defaultComponentStyles.dropdownContentContainer,
      componentStyles?.dropdownContentContainer,
    ],
    backdrop: [defaultComponentStyles.backdrop, componentStyles?.backdrop],
    searchInput: [
      defaultComponentStyles.searchInput,
      componentStyles?.searchInput,
    ],
    creatable: [defaultComponentStyles.creatable, componentStyles?.creatable],
    creatableInput: [
      defaultComponentStyles.creatableInput,
      componentStyles?.creatableInput,
    ],
    creatableTitle: [
      defaultComponentStyles.creatableTitle,
      componentStyles?.creatableTitle,
    ],
    icon: [defaultComponentStyles.icon, componentStyles?.icon],
    tag: [defaultComponentStyles.tag, componentStyles?.tag],
    tagText: [defaultComponentStyles.tagText, componentStyles?.tagText],
    caretIcon: {
      style: [
        defaultComponentStyles?.caretIcon?.style,
        componentStyles?.caretIcon?.style,
      ],
      size:
        componentStyles?.caretIcon?.size ??
        defaultComponentStyles.caretIcon?.size,
      color:
        componentStyles?.caretIcon?.color ??
        defaultComponentStyles.caretIcon?.color,
    },
    clearable: {
      style: [
        defaultComponentStyles?.clearable?.style,
        componentStyles?.clearable?.style,
      ],
      buttonStyle: [
        defaultComponentStyles?.clearable?.buttonStyle,
        componentStyles?.clearable?.buttonStyle,
      ],
      size:
        componentStyles?.clearable?.size ??
        defaultComponentStyles.clearable?.size,
      color:
        componentStyles?.clearable?.color ??
        defaultComponentStyles.clearable?.color,
    },
    tagRemoveIcon: {
      style: [
        defaultComponentStyles?.tagRemoveIcon?.style,
        componentStyles?.tagRemoveIcon?.style,
      ],
      size:
        componentStyles?.tagRemoveIcon?.size ??
        defaultComponentStyles.tagRemoveIcon?.size,
      color:
        componentStyles?.tagRemoveIcon?.color ??
        defaultComponentStyles.tagRemoveIcon?.color,
    },
  };
};
